
import { Vue } from "vue-class-component";

export default class CheckCircle extends Vue {}
